<!--名单公示-->
<template>
  <div>
    <div>
      <top-item-com active="3" :ssid="ssid"></top-item-com>
    </div>
    <div>
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :disabled="!isAtTop"
      >
        <van-tabs v-model="queryType" @change="toTab">
          <van-tab title="组别信息" :name="'ZB'"></van-tab>
          <van-tab title="项目信息" :name="'XM'"></van-tab>
        </van-tabs>
        <van-collapse
          v-model="zbMainActive"
          accordion
          v-if="queryType === 'ZB'"
        >
          <!-- :value="" -->
          <van-collapse-item
            v-for="(mainItem, index) in zbResultList"
            :key="index"
          >
            <template #title>
              <div @click="getItemZbData(mainItem.XMJC)">
                <div
                  v-if="mainItem.ISGSMD === '1'"
                  style="float: left;width: 17px;height: 17px;background: green;border-radius: 100%;margin-right: 10px;"
                ></div>
                <div
                  v-if="mainItem.ISGSMD !== '1'"
                  style="float: left;width: 17px;height: 17px;background: red;border-radius: 100%;margin-right: 10px;"
                ></div>
                {{ mainItem.XMJC }}
                <div style="float: right;">
                  {{ mainItem.ISGSMD === "1" ? mainItem.ZTM + "人" : "" }}
                </div>
              </div>
            </template>
            <van-collapse v-model="zbItemActive" accordion>
              <van-collapse-item
                :name="item.XMID"
                v-for="(item, index) in resultList"
                :key="index"
                @click.native="getMdDataHandler(item)"
                :value="
                  item.ISGSMD === '1'
                    ? item.ZTM +
                      (item.SSLX.substr(1, 2) === 'S'
                        ? '人'
                        : item.SSLX.substr(1, 2) === 'D'
                        ? '对'
                        : '队')
                    : ''
                "
              >
                <template #title>
                  <div>
                    {{ item.SSLXMC }}
                  </div>
                </template>
                <!-- 团体显示模式 开始 -->
                <van-collapse
                  v-model="dwItemActive"
                  accordion
                  v-if="item.SSLX.substr(1, 2) === 'T'"
                >
                  <van-collapse-item
                    :name="item.DWJC"
                    v-for="(item, index) in dwList"
                    :key="index"
                    @click.native="getDwidRmdHandler(item)"
                    :value="item.ZTM + '人'"
                  >
                    <template #title>
                      <div>
                        {{ item.DWJC }}
                      </div>
                    </template>
                    <div class="player-container">
                      <div class="player-grid">
                        <div
                          class="player-card"
                          v-for="(ryItem, ryIndex) in rydList"
                          :key="ryIndex"
                        >
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG1)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG1"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM1 }}
                              <span v-if="ryItem.XB1" class="player-gender">{{ ryItem.XB1 }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC1 }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
                <!-- 团体显示模式结束 -->
                <!-- 单项显示模式 开始 -->
                <div v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <!-- 单人赛 (S) -->
                  <div v-if="item.SSLX.substr(1, 2) === 'S'" class="player-container">
                    <div class="player-grid">
                      <div
                        class="player-card"
                        v-for="(ryItem, ryIndex) in rydList"
                        :key="ryIndex"
                      >
                        <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG1)">
                          <van-image
                            class="player-avatar"
                            :src="ryItem.MGZIMG1"
                            lazy-load
                            fit="cover"
                            round
                          >
                            <template v-slot:loading>
                              <van-loading type="spinner" size="20" />
                            </template>
                          </van-image>
                        </div>
                        <div class="player-info">
                          <div class="player-name">
                            {{ ryItem.RYXM1 }}
                            <span v-if="ryItem.XB1" class="player-gender">{{ ryItem.XB1 }}</span>
                          </div>
                          <div class="player-team">{{ ryItem.DWJC1 }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- 双人赛 (D) -->
                  <div
                    v-if="item.SSLX.substr(1, 2) === 'D' && item.SSLX != 'LD' && item.SSLX != 'GD' && item.SSLX != 'BD'"
                    class="player-container"
                  >
                    <div class="double-player-grid">
                      <div
                        class="double-player-pair"
                        v-for="(ryItem, ryIndex) in rydList"
                        :key="ryIndex"
                      >
                        <div class="pair-member">
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG1)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG1"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM1 }}
                              <span v-if="ryItem.XB1" class="player-gender">{{ ryItem.XB1 }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC1 }}</div>
                          </div>
                        </div>
                        <div class="pair-member">
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG2)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG2"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM2 }}
                              <span v-if="ryItem.XB2" class="player-gender">{{ ryItem.XB2 }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC2 }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- 3v3 特殊赛 (LD/GD/BD) -->
                  <div
                    v-if="item.SSLX === 'LD' || item.SSLX === 'GD' || item.SSLX === 'BD'"
                    class="player-container"
                  >
                    <div class="triple-player-list">
                      <div
                        class="triple-player-card"
                        v-for="(ryItem, ryIndex) in rydList"
                        :key="ryIndex"
                      >
                        <div class="triple-player-item">
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG1)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG1"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM1 }}
                              <span v-if="ryItem.XB1" class="player-gender">{{ ryItem.XB1 }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC1 }}</div>
                          </div>
                        </div>
                        <div class="triple-player-item">
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG2)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG2"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM2 }}
                              <span v-if="ryItem.XB2" class="player-gender">{{ ryItem.XB2 }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC2 }}</div>
                          </div>
                        </div>
                        <div class="triple-player-item">
                          <div class="avatar-wrapper" @click="previewImage(ryItem.MGZIMG_FIN)">
                            <van-image
                              class="player-avatar"
                              :src="ryItem.MGZIMG_FIN"
                              lazy-load
                              fit="cover"
                              round
                            >
                              <template v-slot:loading>
                                <van-loading type="spinner" size="20" />
                              </template>
                            </van-image>
                          </div>
                          <div class="player-info">
                            <div class="player-name">
                              {{ ryItem.RYXM_FIN }}
                              <span v-if="ryItem.XB_FIN" class="player-gender">{{ ryItem.XB_FIN }}</span>
                            </div>
                            <div class="player-team">{{ ryItem.DWJC_FIN }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 单项显示模式 结束 -->
              </van-collapse-item>
            </van-collapse>
          </van-collapse-item>
        </van-collapse>

        <van-collapse v-model="activeNames" accordion v-if="queryType === 'XM'">
          <van-collapse-item
            :name="item.XMID"
            v-for="(item, index) in resultList"
            :key="index"
            @click.native="getMdDataHandler(item)"
            :value="
              item.ISGSMD === '1'
                ? item.ZTM +
                  (item.SSLX.substr(1, 2) === 'S'
                    ? '人'
                    : item.SSLX.substr(1, 2) === 'D'
                    ? '对'
                    : '队')
                : ''
            "
          >
            <template #title>
              <div>
                <div
                  v-if="item.ISGSMD === '1'"
                  style="float: left;width: 17px;height: 17px;background: green;border-radius: 100%;margin-right: 10px;"
                ></div>
                <div
                  v-if="item.ISGSMD !== '1'"
                  style="float: left;width: 17px;height: 17px;background: red;border-radius: 100%;margin-right: 10px;"
                ></div>
                {{ item.XMQC }}
              </div>
            </template>
            <div>
              <div style="color:black">
                <table class="tableClass">
                  <tr>
                    <td>
                      序号
                    </td>
                    <td>
                      运动员
                    </td>
                    <td>
                      性别
                    </td>
                    <td>
                      队伍全称
                    </td>
                    <td>
                      队伍简称
                    </td>
                  </tr>
                  <tr v-for="(ryItem, ryIndex) in rydList" :key="ryIndex">
                    <td>{{ ryIndex + 1 }}</td>
                    <td>
                      {{
                        ryItem.RYXM1 +
                          (ryItem.RYXM2.length == 0 ? "" : "/" + ryItem.RYXM2)
                      }}
                    </td>
                    <td>
                      {{
                        ryItem.XB1 +
                          (ryItem.XB2.length == 0 ? "" : "/" + ryItem.XB2)
                      }}
                    </td>
                    <td>
                      {{ ryItem.DWQC1 }}
                    </td>
                    <td>
                      {{ ryItem.DWJC1 }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-pull-refresh>
    </div>
    <div style="height:100px;width:15px;"></div>
    <loading-com />
    <!-- 返回顶部按钮 -->
    <back-to-top-com />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
import BackToTopCom from "../commonCom/BackToTopCom.vue";
import { Dialog, ImagePreview } from "vant";
export default {
  components: { HeaderCom, LoadingCom, TopItemCom, BackToTopCom },
  name: "MdGsIndex",
  data() {
    return {
      queryType: "ZB",
      isLoading: false,
      activeNames: [],
      zbMainActive: [],
      prevActiveNames: [], // 上一次展开的 name 数组
      zbItemActive: [],
      ssid: "",
      resultList: [],
      rydList: [],
      routeValue: "",
      zbResultList: [],
      xmList: [],
      dwItemActive: [],
      dwList: [],
      isAtTop: true // 是否在顶部
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    if (this.queryType === "ZB") {
      this.mainZbLoadData();
    } else {
      this.mainLoadData();
    }
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 预览图片
    previewImage(imageUrl) {
      if (imageUrl) {
        ImagePreview({
          images: [imageUrl],
          closeable: true,
          closeIconPosition: 'top-right'
        });
      }
    },
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    toTab() {
      this.activeNames = [];
      this.zbMainActive = [];
      this.zbItemActive = [];
      if (this.queryType === "ZB") {
        this.mainZbLoadData();
      } else {
        this.mainLoadData();
      }
    },
    mainZbLoadData() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getAllZbData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        this.isLoading = false;
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.zbResultList = data.content;
      });
    },
    getItemZbData(XMJC) {
      this.mainLoadData(XMJC);
    },
    onRefresh() {
      if (item.ISGSMD !== "1") {
        Dialog.alert({ title: "提示", message: "名单未公示" });
        return;
      }
      if (this.queryType === "ZB") {
        this.mainZbLoadData();
      } else {
        this.mainLoadData();
      }
    },
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    },
    mainLoadData(XMJC) {
      this.resultList = [];
      var busData = {
        XMJC: XMJC
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getAllXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        this.isLoading = false;
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.resultList = data.content;
      });
    },
    getMdDataHandler(item) {
      this.rydList = [];
      if (item.ISGSMD !== "1") {
        Dialog.alert({ title: "提示", message: "名单未公示" });
        return;
      }
      if (this.queryType === "ZB" && item.SSLX.substr(1, 2) === "T") {
        var busData = {
          XMID: item.XMID
        };
        var paramData = {
          headerData: {
            ssid: this.ssid,
            op: "wapGL", //反射名称
            methodName: "getGsmdDwInfoData" //对应的方法名
          },
          busData: busData //参数内容
        };
        this.utilPost.paramData = paramData;
        //alert(JSON.stringify(paramData));
        this.utilPost.sendPost().then(data => {
          // console.log(data);
          if (!data.isSuccess) {
            alert(data.msg);
            return;
          }
          this.dwList = data.content;
        });
      } else {
        var busData = {
          xmid: item.XMID
        };
        var paramData = {
          headerData: {
            ssid: this.ssid,
            op: "wapGL", //反射名称
            methodName: "getGsmdData" //对应的方法名
          },
          busData: busData //参数内容
        };
        this.utilPost.paramData = paramData;
        //alert(JSON.stringify(paramData));
        this.utilPost.sendPost().then(data => {
          // console.log(data);
          if (!data.isSuccess) {
            alert(data.msg);
            return;
          }
          this.rydList = data.content;
        });
      }
    },
    getDwidRmdHandler(item) {
      var busData = {
        xmid: item.XMID,
        DWID: item.DWID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getGsmdData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // console.log(data);
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.rydList = data.content;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}
.van-image--round {
  margin-top: 15px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.textMainDiv {
  padding-top: 15px;
}
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
.tableClass {
  background: #fff;
  width: 100%;
  border-collapse: collapse;
}
.tableClass td {
  width: 100px;
  text-align: center;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 13px;
}
/deep/ .van-collapse-item__content {
  padding: 12px 0px;
}

/* 现代化布局样式 */
.player-container {
  padding: 12px 8px;
  background: #f7f8fa;
}

/* 单人赛网格布局 */
.player-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.player-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px 6px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  
  &:active {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.avatar-wrapper {
  display: inline-block;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:active {
    transform: scale(0.95);
  }
}

.player-avatar {
  width: 48px !important;
  height: 48px !important;
  border: 2px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.player-info {
  margin-top: 8px;
}

.player-name {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  margin-bottom: 4px;
  line-height: 1.4;
  word-break: break-all;
}

.player-gender {
  display: inline-block;
  font-size: 12px;
  color: #1989fa;
  font-weight: normal;
  margin-left: 2px;
}

.player-team {
  font-size: 11px;
  color: #969799;
  line-height: 1.3;
  word-break: break-all;
}

/* 双人赛布局 - 2列网格，一行显示2对 */
.double-player-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.double-player-pair {
  background: #fff;
  border-radius: 12px;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  
  &:active {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.pair-member {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* 3v3布局 - 三个人一行为一对 */
.triple-player-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.triple-player-card {
  background: #fff;
  border-radius: 12px;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  
  &:active {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.triple-player-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/RyGsIndex/MdGsIndex.vue